import { BaseIcon } from '../BaseIcon';
import type { BaseIconProps } from '../BaseIcon';
import { IconSize } from '../../../../enums';

type WarningFilledIconProps = Omit<BaseIconProps, 'children' | 'hasLegacyStrokeStyles'> & {
  size?: IconSize;
};

export const WarningFilledIcon = ({
  strokeWidth,
  size = IconSize.Standard,
  ...props
}: WarningFilledIconProps) => {
  const dimensions = size === IconSize.Mini ? 16 : 24;

  return (
    <BaseIcon
      width={dimensions}
      height={dimensions}
      viewBox="0 0 14 13"
      fill="none"
      strokeWidth={strokeWidth}
      {...props}
    >
      <path d="M1 12L7.00002 0.5L13 12H1Z" fill="#FFD600" />
      <path
        d="M7.00001 0C7.18625 1.94243e-07 7.35718 0.10346 7.44337 0.268555L13.4434 11.7686C13.5242 11.9234 13.5182 12.1094 13.4277 12.2588C13.3371 12.4083 13.1748 12.5 13 12.5H1.00001C0.825186 12.5 0.6629 12.4083 0.572275 12.2588C0.481861 12.1094 0.475848 11.9234 0.55665 11.7686L6.55665 0.268555L6.59278 0.209961C6.68574 0.0793912 6.83694 4.94951e-06 7.00001 0ZM1.8252 11.5H12.1748L7.00001 1.58105L1.8252 11.5Z"
        fill="#FFD600"
      />
      <path
        d="M6.5 8V4.5C6.5 4.22386 6.72386 4 7 4C7.27614 4 7.5 4.22386 7.5 4.5V8C7.5 8.27614 7.27614 8.5 7 8.5C6.72386 8.5 6.5 8.27614 6.5 8Z"
        fill="#332B00"
      />
      <path
        d="M7.5 10C7.5 10.2761 7.27614 10.5 7 10.5C6.72386 10.5 6.5 10.2761 6.5 10C6.5 9.72386 6.72386 9.5 7 9.5C7.27614 9.5 7.5 9.72386 7.5 10Z"
        fill="#332B00"
      />
    </BaseIcon>
  );
};

WarningFilledIcon.displayName = 'WarningFilledIcon';
